import { useMediaQuery } from 'usehooks-ts'

import { Button, Modal, Typography } from 'antd'
import {
  BookingOptions,
  PhysicianBio,
  ShortDisclaimerAlert,
} from '@/src/components'

import { config } from '@fortawesome/fontawesome-svg-core'
import '@fortawesome/fontawesome-svg-core/styles.css'
config.autoAddCss = false
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import '@/src/lib'

import { Physician } from '@/src/interfaces'

const { Title } = Typography

const ModalTitle = ({ physicianName }: { physicianName: string }) => {
  const isMobile = useMediaQuery('(max-width: 768px)')

  return (
    <Title level={isMobile ? 4 : 3} style={{ fontWeight: 400 }}>
      {`Request an appointment with ${physicianName}`}
    </Title>
  )
}

type RequestAppointmentModal = {
  physician: Physician
  isModalVisible: boolean
  setIsModalVisible: (isModalVisible: boolean) => void
  selectedPhysician: Physician | null
  setSelectedPhysician: (selectedPhysician: Physician | null) => void
}

export const RequestAppointmentModal = ({
  physician,
  isModalVisible,
  setIsModalVisible,
  selectedPhysician,
  setSelectedPhysician,
}: RequestAppointmentModal) => {
  const handleCancel = () => {
    setIsModalVisible(false)
    setSelectedPhysician(null)
  }

  return (
    <Modal
      open={isModalVisible}
      onCancel={handleCancel}
      footer={null}
      width='100%'
      style={{ maxWidth: '1000px' }}
    >
      {physician && (
        <div>
          <ModalTitle physicianName={physician.full_name} />
          <PhysicianBio
            physician={physician}
            selectedPhysician={selectedPhysician}
          />
          <BookingOptions
            physician={physician}
            showOnlineBooking={true}
            showPhoneBooking={true}
            isRequestAppointmentModal={true}
          />
          <ShortDisclaimerAlert />
        </div>
      )}
      <Button
        type='default'
        style={{ height: 50, marginTop: 20, border: 'none', boxShadow: 'none' }}
        onClick={handleCancel}
      >
        <FontAwesomeIcon icon='arrow-left' />
        Back to Search
      </Button>
    </Modal>
  )
}
